"use client";
import { RouteError } from "@/components/route-error";
export default function ErrorPage({ reset }: { reset: () => void }) {
  return <RouteError locale="es" reset={reset} />;
}
